// Links to be shown in the AppDrawer
export default [
  {
    to: '/dashboard',
    icon: 'mdi-view-dashboard',
    text: 'ダッシュボード'
  },
  {
    to: '/list',
    icon: 'mdi-car-pickup',
    text: 'リスト作成'
  },
  {
    to: '/customers',
    icon: 'mdi-account-multiple',
    text: '顧客'
  },
  {
    to: '/sensors',
    icon: 'mdi-flash-circle',
    text: 'センサー'
  },
  {
    to: '/groups',
    icon: 'mdi-map-marker',
    text: 'グループ'
  },
  {
    to: '/tank-types',
    // icon: 'mdi-thermostat-box',
    icon: 'mdi-cup-water',
    text: 'タンクタイプ'
  },
  {
    to: '/users',
    icon: 'mdi-account',
    text: 'ユーザ'
  }
]
